import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(({ palette, spacing, layout }) => ({
  headerControl: {
    position: 'relative',
    display: 'flex',
    gap: spacing(3),
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    color: palette.secondary.main,
    textDecoration: 'none',
  },
  iconBtn: {
    marginLeft: `${spacing(2)} !important`,
  },
  avatar: {
    width: layout.avatar.width,
    height: layout.avatar.height,
    color: palette.secondary.main,
    backgroundColor: palette.background.light,
  },
  menu: {
    marginTop: spacing(1),
  },
  link: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    color: palette.secondary.main,
  },
}))

export default useStyles
